import React from 'react';
import ReactDOM from 'react-dom/client';
import JournalPortal from './JournalPortal';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<JournalPortal />);
// Updated
